import SectionHeading from '@/pages/home/components/SectionHeading';
import { collections } from '@/mocks/home';

const toneMap: Record<string, { text: string; bg: string; border: string }> = {
  primary: { text: 'text-primary-600', bg: 'bg-primary-50', border: 'border-primary-200' },
  accent: { text: 'text-accent-700', bg: 'bg-accent-50', border: 'border-accent-200' },
  secondary: { text: 'text-secondary-700', bg: 'bg-secondary-50', border: 'border-secondary-200' },
};

export default function CollectionIndex() {
  return (
    <section id="collections" className="scroll-mt-28 border-b border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          no="02"
          english="Archive Index"
          title="热瓜合集索引"
          desc="零散的快讯容易翻不到，这里按主题归档。想补档、想考古、想一次看全，从索引进最快。"
        />

        {/* 档案室横幅 */}
        <figure className="mt-10 overflow-hidden rounded-lg border border-background-300">
          <div className="relative w-full">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20overhead%20editorial%20flat%20lay%20of%20vintage%20magazines%2C%20polaroid%20style%20photos%2C%20handwritten%20index%20cards%2C%20archive%20folders%20and%20a%20magnifying%20glass%20arranged%20on%20a%20cream%20textured%20paper%20background%2C%20stylized%20archive%20aesthetic%2C%20muted%20oxblood%20and%20mustard%20accents%2C%20fine%20film%20grain%2C%20generous%20negative%20space%2C%20high%20detail&width=1600&height=560&seq=heiliaochigua-archive-band&orientation=landscape"
              alt="黑料吃瓜合集索引档案室"
              title="黑料吃瓜 合集索引 考古档案"
              className="h-full w-full object-top"
              style={{ aspectRatio: '1600 / 560' }}
            />
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/70 via-foreground-950/30 to-transparent" />
            <figcaption className="absolute bottom-5 left-6 right-6 md:bottom-7 md:left-8">
              <p className="font-label text-[11px] tracking-[0.3em] text-accent-300">ARCHIVE ROOM</p>
              <p className="mt-2 font-heading text-xl font-black text-background-50 md:text-2xl">翻旧账专用档案室 · 老瓜新吃</p>
            </figcaption>
          </div>
        </figure>

        {/* 索引网格 */}
        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {collections.map((item, index) => {
            const tone = toneMap[item.tone];
            return (
              <a
                key={item.id}
                href="#topics"
                className="group flex cursor-pointer flex-col rounded-lg border border-background-300 bg-background-50 p-6 transition-colors hover:border-foreground-400 animate-fadeUp"
                style={{ animationDelay: `${index * 60}ms` }}
              >
                <div className="flex items-start justify-between">
                  <span className={`font-heading text-5xl font-black leading-none ${tone.text}`}>{item.no}</span>
                  <span className={`flex h-9 w-9 items-center justify-center rounded-md ${tone.bg} ${tone.border} border`}>
                    <i className={`ri-arrow-right-up-line ${tone.text}`} />
                  </span>
                </div>
                <h3 className="mt-6 font-heading text-xl font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4">
                  <span className="font-label text-[11px] tracking-wide text-foreground-500">共收录</span>
                  <span className="font-heading text-lg font-black text-foreground-900">{item.count} 条</span>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}